import { render } from "./BannerRain.vue?vue&type=template&id=0c79b2fe&scoped=true"
import script from "./BannerRain.vue?vue&type=script&lang=js"
export * from "./BannerRain.vue?vue&type=script&lang=js"

import "./BannerRain.vue?vue&type=style&index=0&id=0c79b2fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c79b2fe"]])

export default __exports__